export default "__VITE_ASSET__B7zIPl42__"